export const GET_MASTER_COURSES_REQUEST = 'GET_MASTER_COURSES_REQUEST';
export const GET_MASTER_COURSES_SUCCESS = 'GET_MASTER_COURSES_SUCCESS';
export const GET_MASTER_COURSES_FAILURE = 'GET_MASTER_COURSES_FAILURE';

export const getMasterCourses = ({ accessStatus }) => ({ type: GET_MASTER_COURSES_REQUEST, accessStatus });

export const getMasterCoursesSuccess = data => ({ type: GET_MASTER_COURSES_SUCCESS, data });

export const getMasterCoursesFailure = () => ({ type: GET_MASTER_COURSES_FAILURE });

export const GET_MASTER_COURSES_BY_COUNTRY_REQUEST = 'GET_MASTER_COURSES_BY_COUNTRY_REQUEST';
export const GET_MASTER_COURSES_BY_COUNTRY_SUCCESS = 'GET_MASTER_COURSES_BY_COUNTRY_SUCCESS';
export const GET_MASTER_COURSES_BY_COUNTRY_FAILURE = 'GET_MASTER_COURSES_BY_COUNTRY_FAILURE';
export const RELOAD_MASTER_COURSES = 'RELOAD_MASTER_COURSES';

export const reloadMasterCourses = () => ({ type: RELOAD_MASTER_COURSES });

export const getMasterCoursesByCountry = countryCode => ({ type: GET_MASTER_COURSES_BY_COUNTRY_REQUEST, countryCode });

export const getMasterCoursesByCountrySuccess = data => ({ type: GET_MASTER_COURSES_BY_COUNTRY_SUCCESS, data });

export const getMasterCoursesByCountryFailure = () => ({ type: GET_MASTER_COURSES_BY_COUNTRY_FAILURE });

export const GET_COUNTRIES_WITH_MASTER_COURSES_REQUEST = 'GET_COUNTRIES_WITH_MASTER_COURSES_REQUEST';
export const GET_COUNTRIES_WITH_MASTER_COURSES_SUCCESS = 'GET_COUNTRIES_WITH_MASTER_COURSES_SUCCESS';
export const GET_COUNTRIES_WITH_MASTER_COURSES_FAILURE = 'GET_COUNTRIES_WITH_MASTER_COURSES_FAILURE';

export const getCountriesWithMasterCourses = () => ({ type: GET_COUNTRIES_WITH_MASTER_COURSES_REQUEST });

export const getCountriesWithMasterCoursesSuccess = data => ({ type: GET_COUNTRIES_WITH_MASTER_COURSES_SUCCESS, data });

export const getCountriesWithMasterCoursesFailure = () => ({ type: GET_COUNTRIES_WITH_MASTER_COURSES_FAILURE });

export const CHANGE_MASTER_COURSE_COUNTRY = 'CHANGE_MASTER_COURSE_COUNTRY';

export const changeMasterCourseCountry = countryCode => ({ type: CHANGE_MASTER_COURSE_COUNTRY, countryCode });

// Subjects
export const GET_SUBJECTS_REQUEST = 'GET_SUBJECTS_REQUEST';
export const GET_SUBJECTS_SUCCESS = 'GET_SUBJECTS_SUCCESS';
export const GET_SUBJECTS_FAILURE = 'GET_SUBJECTS_FAILURE';
export const CHANGE_SUBJECT = 'CHANGE_SUBJECT';
export const getSubjects = () => ({ type: GET_SUBJECTS_REQUEST });
export const getSubjectsSuccess = data => ({ type: GET_SUBJECTS_SUCCESS, data });
export const getSubjectsFailure = () => ({ type: GET_SUBJECTS_FAILURE });
export const changeSubject = subject => ({ type: CHANGE_SUBJECT, subject });

export const CHANGE_MASTER_COURSE_CURRICULUM_TYPE = 'CHANGE_MASTER_COURSE_CURRICULUM_TYPE';

export const changeCurriculumType = curriculumCode => ({ type: CHANGE_MASTER_COURSE_CURRICULUM_TYPE, curriculumCode });



// WEBPACK FOOTER //
// ./app/containers/master-courses/actions.js